import { useQuery } from '@apollo/client';

import query from './account.graphql';

export default function useCurrentAccount() {
  const { data, loading, refetch } = useQuery(query);

  return {
    account: data?.account,
    loading,
    refetch,
  };
}
